/* Suparno Karmakar */
import React from 'react';
import About from './About/About';

export default function AboutUs(props){
    return (
        <section className='about'>
            <About/>
        </section>
    )
}